export default __webpack_public_path__ + "static/media/07_photo.b7cc800d.jpg";